export function TeelogixLogo() {
  return (
    <svg
      width="360"
      height="76"
      viewBox="0 0 360 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-auto w-48 sm:w-60 md:w-72"
    >
      <path
        d="M41.9542 12.3085C41.8278 11.4083 40.919 10.9772 39.9252 11.3431C38.9293 11.7091 38.2254 12.7351 38.3518 13.6353C38.4782 14.5356 39.3869 14.9666 40.3807 14.6007C41.3767 14.2348 42.0806 13.2088 41.9542 12.3085Z"
        fill="#FF9D42"
      />
      <path
        d="M35.7474 16.4327C35.9261 15.4808 35.5426 14.814 34.8909 14.9419C34.2393 15.0699 33.5659 15.9432 33.3872 16.8929C33.2085 17.8448 33.592 18.5116 34.2437 18.3836C34.8953 18.2556 35.5687 17.3823 35.7474 16.4327Z"
        fill="#FF9D42"
      />
      <path
        d="M32.5786 20.4064C32.5067 19.7194 32.1341 19.3333 31.7439 19.5443C31.3538 19.7576 31.0967 20.485 31.1686 21.1742C31.2405 21.8612 31.6132 22.2473 32.0033 22.0363C32.3934 21.823 32.6506 21.0956 32.5786 20.4064Z"
        fill="#FF9D42"
      />
      <path
        d="M53.7097 12.3085C53.8361 11.4083 54.7449 10.9772 55.7386 11.3431C56.7346 11.7091 57.4385 12.7351 57.3121 13.6353C57.1857 14.5356 56.2769 14.9666 55.2832 14.6007C54.2872 14.2348 53.5833 13.2088 53.7097 12.3085Z"
        fill="#FF9D42"
      />
      <path
        d="M59.9143 16.4327C59.7356 15.4808 60.1191 14.814 60.7708 14.9419C61.4224 15.0699 62.0958 15.9432 62.2745 16.8929C62.4532 17.8448 62.0697 18.5116 61.418 18.3836C60.7664 18.2556 60.093 17.3823 59.9143 16.4327Z"
        fill="#FF9D42"
      />
      <path
        d="M63.0853 20.4064C63.1572 19.7194 63.5298 19.3333 63.9199 19.5443C64.31 19.7576 64.5672 20.485 64.4953 21.1742C64.4234 21.8612 64.0507 22.2473 63.6606 22.0363C63.2705 21.823 63.0133 21.0956 63.0853 20.4064Z"
        fill="#FF9D42"
      />
      <path
        d="M64.1706 16.482C63.9853 16.5606 63.665 16.5965 63.2422 16.2553C62.5273 15.6985 62.7714 14.2864 61.9346 12.78C61.0933 11.2533 60.0233 11.4644 60.2564 12.6183C60.494 13.7723 59.5896 14.1315 58.3234 12.8159C57.0506 11.5048 57.2903 10.2139 55.9588 9.25077C54.832 8.45602 53.8557 8.90278 53.6247 9.95122C53.3871 10.975 52.1907 11.4711 51.3887 11.2084C50.5758 10.9458 50.2554 9.95122 49.6517 8.76808C49.2333 7.93742 48.7102 7.51759 47.8341 7.51759C46.958 7.51759 46.435 7.93742 46.0165 8.76808C45.4129 9.95346 45.0925 10.9458 44.2796 11.2084C43.4776 11.4711 42.2811 10.975 42.0436 9.95122C41.8104 8.90503 40.8362 8.45602 39.7095 9.25077C38.3801 10.2139 38.6176 11.507 37.3449 12.8159C36.0787 14.1315 35.1721 13.7723 35.4118 12.6183C35.645 11.4644 34.5749 11.2533 33.7337 12.78C32.8968 14.2886 33.1409 15.6985 32.4261 16.2553C32.0011 16.5965 31.6829 16.5606 31.4977 16.482C33.7097 9.36302 40.1846 4.21289 47.8276 4.21289H47.8385C55.4815 4.21289 61.9563 9.36302 64.1684 16.482H64.1706Z"
        fill="#FF9D42"
      />
      <path
        d="M16.6497 19.8519L31.9597 25.7518V25.7563C31.9968 25.8124 32.0294 25.8618 32.0665 25.918L46.2476 64.9705H44.3079C42.9219 64.9705 41.7058 64.0231 41.3288 62.6491L39.5962 56.3562C38.5632 52.607 36.4165 48.979 32.8772 47.6096L23.6564 44.0579C20.0059 42.657 17.3646 39.3433 16.7304 35.3831L14.5379 21.6412C14.344 20.4064 15.5121 19.4208 16.6519 19.8519H16.6497Z"
        fill="#22577A"
      />
      <path
        d="M34.9127 26.8923C38.5631 28.2999 41.2045 31.6069 41.8344 35.5672L46.5243 64.9705H45.8073L30.4102 25.1614L34.9127 26.8946V26.8923Z"
        fill="#57CC99"
      />
      <path
        d="M79.0098 19.8519L63.6998 25.7518V25.7563C63.6628 25.8124 63.6301 25.8618 63.593 25.918L49.412 64.9705H51.3516C52.7377 64.9705 53.9538 64.0231 54.3308 62.6491L56.0634 56.3562C57.0964 52.607 59.2431 48.979 62.7823 47.6096L72.0032 44.0579C75.6536 42.657 78.295 39.3433 78.9292 35.3831L81.1238 21.6389C81.3177 20.4041 80.1496 19.4186 79.0098 19.8496V19.8519Z"
        fill="#22577A"
      />
      <path
        d="M60.749 26.8923C57.0986 28.2999 54.4572 31.6069 53.8274 35.5672L49.1374 64.9705H49.8544L65.2515 25.1591L60.749 26.8923Z"
        fill="#57CC99"
      />
      <path
        d="M47.8298 13.4602C49.0165 13.4602 49.9786 12.6491 49.9786 11.6485C49.9786 10.6479 49.0165 9.83672 47.8298 9.83672C46.643 9.83672 45.6809 10.6479 45.6809 11.6485C45.6809 12.6491 46.643 13.4602 47.8298 13.4602Z"
        fill="#FF9D42"
      />
      <path
        d="M114.304 62.337V26.5578H98.3015V19.908H137.31V26.5578H121.368V62.337H114.304Z"
        fill="#112C3D"
      />
      <path
        d="M149.961 62.9612C139.533 62.9612 133.306 56.8277 133.306 46.5544C133.306 36.2811 139.951 30.0848 149.839 30.0848C159.727 30.0848 165.827 35.8455 165.827 45.1176C165.827 46.3344 165.755 47.201 165.578 48.1102L165.532 48.3482H140.019C140.356 54.2818 143.377 56.9332 149.778 56.9332C155.579 56.9332 158.402 55.1305 158.402 51.4216V50.6247H165.524V51.4823C165.524 58.2376 159.123 62.9567 149.961 62.9567V62.9612ZM159.066 44.0108C159.003 38.6114 155.943 35.987 149.717 35.987C143.49 35.987 140.55 38.5396 140.086 44.0108H159.066Z"
        fill="#112C3D"
      />
      <path
        d="M186.873 62.9612C176.444 62.9612 170.218 56.8277 170.218 46.5544C170.218 36.2811 176.863 30.0848 186.751 30.0848C196.638 30.0848 202.738 35.8455 202.738 45.1176C202.738 46.3366 202.666 47.2055 202.49 48.1102L202.444 48.3482H176.93C177.268 54.2818 180.289 56.9332 186.692 56.9332C192.493 56.9332 195.313 55.1305 195.313 51.4216V50.6247H202.435V51.4823C202.435 58.2376 196.035 62.9567 186.873 62.9567V62.9612ZM195.98 44.0108C195.917 38.6114 192.857 35.987 186.631 35.987C180.404 35.987 177.464 38.5396 177 44.0108H195.98Z"
        fill="#112C3D"
      />
      <path
        d="M214.197 19.908H207.075V62.3393H214.197V19.908Z"
        fill="#112C3D"
      />
      <path
        d="M235.368 62.9612C225.188 62.9612 218.349 56.3675 218.349 46.5544C218.349 36.7413 225.188 30.0848 235.368 30.0848C245.547 30.0848 252.447 36.7031 252.447 46.5544C252.447 56.4056 245.584 62.9612 235.368 62.9612ZM235.368 36.6111C228.533 36.6111 225.351 39.7699 225.351 46.5544C225.351 53.3389 228.533 56.3742 235.368 56.3742C242.202 56.3742 245.445 53.2536 245.445 46.5544C245.445 39.8552 242.243 36.6111 235.368 36.6111Z"
        fill="#112C3D"
      />
      <path
        d="M272.709 73.578C263.366 73.578 257.327 68.8297 257.327 61.4794V61.1831H264.388V61.4794C264.388 65.7697 266.742 67.3637 273.073 67.3637C280.005 67.3637 282.119 65.3611 282.119 58.7944V51.7966C280.722 56.6503 276.231 59.5285 269.98 59.5285C261.115 59.5285 255.387 53.7498 255.387 44.8078C255.387 35.8657 261.282 30.087 270.405 30.087C276.73 30.087 281.223 32.9651 282.605 37.8391V30.7134H289.182V58.4239C289.182 68.3403 283.486 73.5825 272.711 73.5825L272.709 73.578ZM272.284 36.5482C265.565 36.5482 262.57 39.0964 262.57 44.8055C262.57 50.5146 265.51 53.1256 272.103 53.1256C278.695 53.1256 282.119 50.335 282.119 45.0547V44.1814C282.119 39.258 278.626 36.5482 272.284 36.5482Z"
        fill="#112C3D"
      />
      <path
        d="M300.833 30.7089H293.711V62.337H300.833V30.7089Z"
        fill="#112C3D"
      />
      <path
        d="M328.099 46.4444L341.409 62.337H332.711L322.712 50.472H322.544L312.667 62.337H304.085L317.399 46.5701V46.4152L304.078 30.7066H312.783L320.99 40.3379V40.3424L322.786 42.4482H322.891L332.767 30.7066H341.419L328.099 46.2917V46.4444Z"
        fill="#112C3D"
      />
      <path
        d="M300.764 28.1607V20.9699H293.783V28.1607H300.764Z"
        fill="#FF9D42"
      />
      <path
        d="M341.419 30.7066L328.099 46.2895V46.4444C326.885 46.4444 325.578 45.7215 324.771 44.7831L322.786 42.446H322.891L332.767 30.7044H341.419V30.7066Z"
        fill="#22577A"
      />
    </svg>
  );
}
